import { Dropdown } from "react-bootstrap";
import SuccessSignIcon from "../../icons/success-sign.icon";
import useDropdown from "../../../hooks/dropdown.hook";
import cn from "../../../Utils/class-names.utils";

interface IItem {
  label: string;
  value: string;
  icon?: React.ReactNode;
  image?: string;
}

interface IProps {
  title?: string;
  className?: string;
  toggleClassName?: string;
  menuClassName?: string;
  list?: IItem[];
  children?: React.ReactNode;
  selected?: IItem | null;
  showSelectedIcon?: boolean;
  popperConfig?: any;
  disabled?: boolean;
  onItemSelected?: (item: IItem) => void;
}

const DropdownSelector = ({ 
  title = '', 
  className = '',
  toggleClassName = '',
  menuClassName = '',
  list = [],
  children,
  selected,
  showSelectedIcon = true,
  popperConfig,
  disabled = false,
  onItemSelected = () => {}, 
}: IProps) => {
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({  });
  return (
    <Dropdown 
      show={isOpen && !disabled} 
      onToggle={() => setIsOpen(prev => !prev)} 
      className={cn('transparennt-wrapper-dropdown my-dropdown my-dropdown-common', className)}
    >
      <Dropdown.Toggle ref={refBtn} className={cn(toggleClassName)}>
        {children}
      </Dropdown.Toggle>
      <Dropdown.Menu renderOnMount ref={refMenu} className={cn('menu', menuClassName)} popperConfig={popperConfig}>
        <div>
          {title && (
            <h3 className="title mb-0">
              {title}
            </h3>
          )}
          {list.map((item, index) => {
            const isSelected = selected && item.value === selected.value;
            return (
              <div className="item d-flex align-items-center gap-4" key={index} onClick={() => {
                onItemSelected(item);
                setIsOpen(false);
              }}>
                {showSelectedIcon && (
                  <div className="d-flex align-items-center justify-content-center" style={{ width: '16px', height: '16px' }}>
                    <SuccessSignIcon width={12} height={9} className={isSelected ? "f-grey" : "f-transparent"} />
                  </div>
                )}
                {item.icon && (
                  <div className="icon">
                    {item.icon}
                  </div>
                )}
                {item.image && (
                  <img src={item.image} alt={item.label} className="image" />
                )}
                <span>{item.label}</span>
              </div>
            )
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropdownSelector;
